"use client";

import { Link } from "@/i18n/navigation";
import { DynamicLucideIcon } from "@/components/icons/dynamic-lucide-icon";
import { POPULAR_PROJECT_CATEGORY_ID } from "@/lib/constants";

interface FieldOfWork {
    id: string;
    title: string;
    icon?: string;
}

interface ProjectFieldsOfWorkProps {
    fieldsOfWork: FieldOfWork[];
}

export function ProjectFieldsOfWork({ fieldsOfWork }: ProjectFieldsOfWorkProps) {
    const filtered = fieldsOfWork.filter((fow) => fow.id !== POPULAR_PROJECT_CATEGORY_ID);

    if (filtered.length === 0) return null;

    return (
        <div className="flex flex-wrap gap-2 mb-4 justify-center md:justify-start">
            {filtered.map((fow) => (
                <Link
                    key={fow.id}
                    href={`/fields-of-work/${fow.id}`}
                    className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-black/5 dark:bg-black/30 backdrop-blur-sm border border-white/15 dark:border-white/10 text-foreground hover:bg-black/10 dark:hover:bg-black/40 transition-colors"
                >
                    {fow.icon && <DynamicLucideIcon name={fow.icon} size={14} className="inline-block mr-1" />}
                    {fow.title}
                </Link>
            ))}
        </div>
    );
}
